<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        @if (back && ids) {
          <button class="mr-0 mr-sm-16" mat-icon-button (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
          </button>
        }
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom>location_city</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom>{{'main.communications' | translate}}</span>
      </div>
      <!-- / APP TITLE -->


      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>

        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->

        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->

      <mat-form-field class="">
        <mat-select placeholder="{{'frontUser.type' | translate}}" [(ngModel)]="selectedType"
          (valueChange)="changeType($event)">
          <mat-option [value]="'mail'">
            {{'user.email' | translate}}
          </mat-option>
          <mat-option [value]="'serial'">
            {{'frontUser.Serial_Letter' | translate}}
          </mat-option>
          <mat-option [value]="'sms'">
            {{'SMS' | translate}}
          </mat-option>
          @if (whatsapp) {
            <mat-option [value]="'whatsapp'">
              {{'main.whatsapp' | translate}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>


    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    @if (communications.length) {
      <div class="content-card mat-white-bg">
        @if (selectedType === 'mail') {
          <div class="mail-content">
            <div class="all-emails">
              @for (mails of communications; track mails) {
                <div class="email" (click)="chooseMail(mails, mails.id)" id="{{mails.id}}">
                  <div class="date">{{mails.createdAt | date: 'EEE, d. MMMM yyyy HH:mm'}}</div>
                  @if (mails.usersShort && mails.usersShort.length) {
                    <div class="users">
                      @for (name of mails.usersShort; track name; let last = $last) {
                        <span>
                          {{name.firstName}} {{name.lastName}}@if (!last) {
                          <span>, </span>
                        }
                      </span>
                    }
                  </div>
                }
                @if (!mails.usersShort || !mails.usersShort.length) {
                  <div class="users">
                    <span>
                      {{mails?.data?.mails}}
                    </span>
                  </div>
                }
                <div class="title">
                  {{mails?.data?.subject}}
                </div>
              </div>
            }
          </div>
          <div class="email-description">
            @if (mailTitle) {
              <div class="ed-title">{{mailTitle}}</div>
            }
            @if (mailUsers) {
              <div class="ed-users">{{mailUsers}}</div>
            }
            @if (mailBody) {
              <div class="show-more" >
                <span style="line-height: 30px" (click)="editType(chosenEmail)">{{'showDetails' | translate}}</span>
                <span style="margin-left: 30px; float: right;" (click)="deleteMessage(chosenEmail)"><mat-icon>delete</mat-icon></span>
              </div>
            }
            @if (mailBody) {
              <div [innerHTML]="mailBody">
              </div>
            }
            @if (mailDocs.length) {
              <div class="documents">
                <div class="message-box">
                  {{'main.uplodedFile' | translate}}
                </div>
                @for (file of mailDocs; track file) {
                  <div >
                    <div class="file-data">
                      @switch (file.type) {
                        @case ('doc') {
                          <img src="assets/images/icons/doc.svg" style="width: 35px">
                        }
                        @case ('docx') {
                          <img src="assets/images/icons/docx.svg" style="width: 35px">
                        }
                        @case ('jpg') {
                          <img src="assets/images/icons/img.svg" style="width: 35px">
                        }
                        @case ('jpeg') {
                          <img src="assets/images/icons/img.svg" style="width: 35px">
                        }
                        @case ('png') {
                          <img src="assets/images/icons/img.svg" style="width: 35px">
                        }
                        @case ('gif') {
                          <img src="assets/images/icons/img.svg" style="width: 35px">
                        }
                        @case ('svg') {
                          <img src="assets/images/icons/img.svg" style="width: 35px">
                        }
                        @case ('pdf') {
                          <img src="assets/images/icons/pdf.svg" style="width: 35px">
                        }
                        @case ('txt') {
                          <img src="assets/images/icons/txt.svg" style="width: 35px">
                        }
                        @case ('xls') {
                          <img src="assets/images/icons/xls.svg" style="width: 35px">
                        }
                        @default {
                          <img src="assets/images/icons/file.svg" style="width: 35px">
                        }
                      }
                      <span class="file-name">{{file.name}}</span>
                      <a [href]="getFile(file.url)" target="_blank" rel="noopener noreferrer" ><mat-icon class="remove-icon">cloud_download</mat-icon></a>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (selectedType === 'serial') {
        <div class="serial-content">
          <div class="all-serials">
            @for (serial of communications; track serial) {
              <div class="serial" (click)="createPdf(serial, serial.id)" id="{{serial.id}}">
                <div class="date">{{serial.createdAt | date: 'EEE, d. MMMM yyyy HH:mm'}}</div>
                @if (serial.usersShort && serial.usersShort.length) {
                  <div class="users">
                    @for (name of serial.usersShort; track name; let last = $last) {
                      <span>
                        {{name.firstName}} {{name.lastName}}@if (!last) {
                        <span>, </span>
                      }
                    </span>
                  }
                </div>
              }
              @if (!serial.usersShort || !serial.usersShort.length) {
                <div class="users">
                  <span>
                    {{serial?.data?.mails}}
                  </span>
                </div>
              }
              <div class="title">
                {{serial?.data?.subject}}
              </div>
            </div>
          }
        </div>
        <div class="serial-description">
          @if (mailTitle) {
            <div class="ed-title">{{mailTitle}}</div>
          }
          @if (!mailTitle) {
            <div class="ed-title">{{'communication.serial.info' | translate}}</div>
          }
          @if (mailUsers) {
            <div class="ed-users">{{mailUsers}}</div>
          }
          <div class="show-more">
            <span style="line-height: 30px" (click)="editType(chosenEmail)">{{'showDetails' | translate}}</span>
            <span style="margin-left: 30px; float: right;" (click)="deleteMessage(chosenEmail)"><mat-icon>delete</mat-icon></span>
          </div>
          <div id="example2"></div>
        </div>
      </div>
    }
    @if (selectedType === 'sms') {
      <div class="sms-content">
        <div class="all-sms">
          @for (sms of communications; track sms) {
            <div class="sms" (click)="creatSMS(sms, sms.id)" id="{{sms.id}}">
              <div class="date">{{sms.createdAt | date: 'EEE, d. MMMM yyyy HH:mm'}}</div>
              @if (sms?.data?.numbers) {
                <div class="users">
                  <span>
                    {{sms?.data?.numbers}}
                  </span>
                </div>
              }
              <div class="title">
                {{sms?.description}}
              </div>
            </div>
          }
        </div>
        <div class="sms-description">
          @if (mailTitle) {
            <div class="ed-title">{{mailTitle}}</div>
          }
          @if (!mailTitle) {
            <div class="ed-title">{{'communication.sms.title' | translate}}</div>
          }
          @if (mailUsers) {
            <div class="ed-users">{{mailUsers}}</div>
          }
          <div class="show-more">
            <span (click)="editType(chosenEmail)">{{'showDetails' | translate}}</span>
          </div>
          <div class="message-container">
            <div class="message">
              {{smsText}}
            </div>
          </div>
        </div>
      </div>
    }
    @if (selectedType === 'whatsapp') {
      <div class="sms-content">
        <div class="all-sms">
          @for (wa of communications; track wa) {
            <div class="sms" (click)="creatSMS(wa, wa.id)" id="{{wa.id}}">
              <div class="date">{{wa.createdAt | date: 'EEE, d. MMMM yyyy HH:mm'}}</div>
              @if (wa?.data?.numbers) {
                <div class="users">
                  <span>
                    {{wa?.data?.numbers}}
                  </span>
                </div>
              }
              <div class="title">
                {{wa?.description}}
              </div>
            </div>
          }
        </div>
        <div class="sms-description">
          @if (mailTitle) {
            <div class="ed-title">{{mailTitle}}</div>
          }
          @if (!mailTitle) {
            <div class="ed-title">{{'communication.whatsapp.title' | translate}}</div>
          }
          @if (mailUsers) {
            <div class="ed-users">{{mailUsers}}</div>
          }
          <div class="show-more">
            <span (click)="editType(chosenEmail)">{{'showDetails' | translate}}</span>
          </div>
          <div class="message-container">
            <div class="message">
              {{smsText}}
            </div>
          </div>
        </div>
      </div>
    }
    <!--      <mat-table class="products-table"-->
    <!--                 #table [dataSource]="communications"-->
    <!--                 matSort-->
    <!--                 [@animateStagger]="{value:'50'}"-->
    <!--                 fusePerfectScrollbar *ngIf="selectedType === 'sms'" >-->
    <!--        <ng-container cdkColumnDef="type">-->
    <!--          <mat-header-cell [ngClass]="'customWidthClass'" *cdkHeaderCellDef mat-sort-header>{{'frontUser.type' |-->
    <!--              translate}}-->
  <!--          </mat-header-cell>-->
  <!--          <mat-cell *cdkCellDef="let comm" [ngClass]="'customWidthClass'">-->
  <!--            <mat-icon *ngIf="comm.type === 'sms'">textsms</mat-icon>-->
  <!--            <mat-icon *ngIf="comm.type === 'mail'">email</mat-icon>-->
  <!--            <mat-icon *ngIf="comm.type === 'serial'">receipt</mat-icon>-->
<!--          </mat-cell>-->
<!--        </ng-container>-->
<!--        <ng-container cdkColumnDef="names">-->
<!--          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.name' | translate}}</mat-header-cell>-->
<!--          <mat-cell *cdkCellDef="let comm">-->
<!--            <mat-icon (click)="openBottomSheet($event, comm)">supervisor_account</mat-icon>-->
<!--          </mat-cell>-->
<!--        </ng-container>-->
<!--        <ng-container cdkColumnDef="description">-->
<!--          <mat-header-cell [ngClass]="'customWidthClass1'" *cdkHeaderCellDef mat-sort-header>{{'event.description' |-->
<!--              translate}}-->
<!--          </mat-header-cell>-->
<!--          <mat-cell [ngClass]="'customWidthClass1'" *cdkCellDef="let comm">-->
<!--            <span *ngIf="comm.type !== 'mail'">{{comm.description}}</span>-->
<!--            <span *ngIf="comm.type === 'mail'">{{comm?.data?.subject}}</span>-->
<!--          </mat-cell>-->
<!--        </ng-container>-->
<!--        <ng-container cdkColumnDef="name">-->
<!--          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'event.title' | translate}}-->
<!--          </mat-header-cell>-->
<!--          <mat-cell *cdkCellDef="let comm">-->
<!--          <span>-->
<!--            {{comm.name}}-->
<!--          </span>-->
<!--          </mat-cell>-->
<!--        </ng-container>-->
<!--        <ng-container cdkColumnDef="sent">-->
<!--          <mat-header-cell [ngClass]="'customWidthClass1'" *cdkHeaderCellDef mat-sort-header>{{'event.sent' |-->
<!--              translate}}-->
<!--          </mat-header-cell>-->
<!--          <mat-cell *cdkCellDef="let comm">-->
<!--    <span>-->
<!--      {{comm.createdAt | date: 'EEE, d. MMMM HH:mm'}}-->
<!--    </span>-->
<!--          </mat-cell>-->
<!--        </ng-container>-->
<!--        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>-->
<!--        <mat-row *cdkRowDef="let comm; columns: displayedColumns;"-->
<!--                 class="product"-->
<!--                 matRipple-->
<!--                 (click)="editType(comm)">-->
<!--        </mat-row>-->
<!--      </mat-table>-->
<mat-paginator #paginator [style.dislay]="communications.length ? 'block' : 'none'"
  [length]="pagination?.total"
  [pageIndex]="_pageIndex"
  [pageSize]="_perPage"
  [pageSizeOptions]="[25, 50, 100]"
  (page)="changePageEmitter($event)">
</mat-paginator>
</div>
}
@if (communications.length === 0) {
  <div class="no-data-msg">
    <span class="mat-headline-6">{{'main.noData' | translate}}</span>
  </div>
}
<!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->
</div>
